import React, { useContext, useState } from 'react';
import { DropdownWrapper, Header, HeaderButtons } from '../styles';
import ViewportContext from '../../../../../components/viewport/context';
import SortOptionsBase from '../offer-list-sorting/sort-options-base';
import FilterToggleButton from '../offer-list-filters/components/filter-toggle-button';
import FilterOptionsPanel from '../offer-list-filters/components/filter-options-panel';

const PriceListHeader: React.FC = () => {
  const { isMobile } = useContext(ViewportContext);
  const [showFilters, setShowFilters] = useState<boolean>(false);

  return (
    <Header data-test="PricePanelHeader">
      <HeaderButtons>
        <DropdownWrapper>
          <FilterToggleButton onToggle={setShowFilters} />
        </DropdownWrapper>
        <DropdownWrapper>
          <SortOptionsBase compact={isMobile} />
        </DropdownWrapper>
      </HeaderButtons>
      <FilterOptionsPanel visible={showFilters} />
    </Header>
  );
};

export default PriceListHeader;
